<template>
  <div>
    <ModalProvider />

    <Header></Header>

    <main class="app">
      <Aside></Aside>

      <div class="main">
        <router-view />
      </div>

      <OpenAppStoreNotification />

      <Transition name="notification_animation">
        <MyNotification v-if="notification?.visible">
          {{ notification?.message }}
        </MyNotification>
      </Transition>
    </main>

  </div>
</template>

<script>
import ModalProvider from "@/UI/Modals/ModalProvider.vue"
import Header from "./components/Header.vue";
import Aside from "./components/Aside.vue";
import OpenAppStoreNotification from "@/UI/OpenAppStoreNotification.vue";
import MyNotification from "@/UI/MyNotification.vue";
import { useNotificationStore } from "./stores/notificationStore";

export default {
  name: "App",
  components: {
    Header,
    Aside,
    ModalProvider,
    OpenAppStoreNotification,
    MyNotification
  },
  data() {
    return {
      notification: useNotificationStore()
    }
  },
  mounted() {
    const savedTheme = localStorage.getItem("theme") || "dark";
    document.documentElement.setAttribute("data-theme", savedTheme);
  },
};
</script>

<style>
main {
  display: flex;
  justify-content: center;
  padding: 32px 0;
  margin-top: 56px;
}

.main {
  width: min(100%, 1000px);
}


img[data-dark][data-light] {
  transition: opacity 0.3s ease;
}
</style>
